import { motion } from 'framer-motion';
import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  .reset {
    input {
      margin: 1rem;
      height: 4rem;
      width: 60%;
      border-radius: 1rem;
      border: 1px solid #a6a6a6;
      outline: none;
      padding: 0 1rem;
      font-size: 18px;
      font-weight: 600;
    }
    label {
      width: 60%;
      text-align: left;
      padding-left: 1rem;
      font-weight: 600;
    }
  }
  .lds-dual-ring {
  display: inline-block;
  width: 80px;
  height: 80px;
}
.lds-dual-ring:after {
  content: " ";
  display: block;
  width: 4rem;
  height: 4rem;
  margin: 8px;
  border-radius: 50%;
  border: 6px solid var(--color-primary);
  border-color: var(--color-primary) transparent var(--color-primary) transparent;
  animation: lds-dual-ring 1.2s linear infinite;
}
@keyframes lds-dual-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

`;

export const Content = styled(motion.form)`
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 60%;
  width: 40%;
  border: 1px solid #a6a6a6;
  border-radius: 2rem;
  box-shadow: 1rem 1rem 1rem #a6a6a6;
  p {
    width: 70%;
    text-align: center;
    color: #a6a6a6;
    font-weight: 600;
    font-size: 18px;
  }
  input {
    margin: 2rem;
    height: 4rem;
    width: 60%;
    border-radius: 1rem;
    border: 1px solid #a6a6a6;
    outline: none;
    padding: 0 1rem;
    font-size: 18px;
    font-weight: 600;
  }
  .code {
    text-align: center;
  }

  img {
    margin-top: -2rem;
    height: 6rem;
    margin-bottom: 3rem;
  }
  button {
    height: 4rem;
    width: 60%;
    background-color: var(--color-primary);
    border: none;
    border-radius: 1rem;
    font-weight: 700;
    font-size: 1.5rem;
    color: #fff;

    &:disabled {
      background-color: #bdc3c7;
      cursor: not-allowed;
    }
  }
`;
export const BackButton = styled.button`
  margin: 4rem 4rem 0 -38rem;
  align-self: center;
  font-weight: 600;
  padding: 1rem;
  display: flex;
  align-items: center;
  background: none;
  border: none;
  span {
    margin: 1rem;
    font-weight: bold;
  }
`;
